<template>
  <div class="text-center">
    <div class="benefit-icon mb-5">
      <strapi-image
        v-if="benefit.icon"
        data-testid="benefit-section-icon"
        :image="benefit.icon"
        :alt="benefit.title"
        :force-height="40"
        :force-width="40"
      />
    </div>

    <p
      data-testid="benefit-section-title"
      class="text-2xl/[1.2] max-sm:text-xl/[1.2] font-bold mt-5 mb-2 uppercase"
      role="heading"
      aria-level="2"
    >
      {{ benefit.title }}
    </p>

    <common-md-content
      v-once
      v-slot="{ renderedContent }"
      :content="safeContent"
    >
      <div v-html="renderedContent"></div>
    </common-md-content>
  </div>
</template>

<script setup lang="ts">
import type { StrapiBenefitContent } from '~/apollo/types/types';
import CommonMdContent from '~/components/common/MdContent.vue';

const props = defineProps<{
  benefit: StrapiBenefitContent & { title: string };
}>();

if (import.meta.dev && (!props.benefit || !props.benefit.title)) {
  console.warn('StrapiBenefitsItem: benefit.title is required.');
}

const safeContent = computed(() =>
  typeof props.benefit?.content === 'string' ? props.benefit.content : '',
);
</script>

<style scoped>
.benefit-icon {
  width: 40px;
  height: 40px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.benefit-icon :deep(img),
.benefit-icon :deep(svg) {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
</style>
